import { useIsNewStackEvent } from './useIsNewStackEvent';

/**
 * Can this event send free cards — the free ecards (`/edit/ecard/*`) and the free photo
 * save-the-date (`/edit/savethedate`)?
 *
 * No for a new-stack wedding: the free send addresses recipients by person id, which a
 * contact_service roster has none of, so the host picks guests, sends, and reaches nobody.
 * Product (Evan, 2026-09-30): new-stack weddings won't support free cards. Premium cards
 * (`/edit/cards/*`) are unaffected.
 *
 * One accessor so the tiles that lead to those routes and the `FreeCardGuard` that redirects them
 * cannot disagree — a tile that renders and then bounces is the bug this closes.
 *
 * Lives in `@shared` rather than beside the guard because `@apps/card` needs it too, and an app may
 * not import another app. Like `useIsNewStackEvent`, deliberately NOT re-exported from the
 * `@shared/utils/eventInfo` barrel: specs that mock the barrel with only `useEventInfo` would get
 * `undefined` here. Import it from this path.
 *
 * While the event read is still pending `usesNewStack` is false, so this returns true and entry
 * points render exactly as they do today; the guard catches the click once the event arrives.
 */
export const useCanUseFreeCards = (): boolean => {
  const isNewStackEvent = useIsNewStackEvent();

  return !isNewStackEvent;
};
